import { useMemo, useRef, useState, useCallback } from "react";
import useMeasure from "react-use-measure";
import { mergeRefs } from "leva/plugin";
import { SmallSvg } from "../styles/StyledBezier";
import type { Bezier as BezierType, BezierProps } from "../types/bezier-types";

const useRange = () => {
	return useCallback((v: number, size) => size * v, []);
};

const useInvertedRange = () => {
	return useCallback((v: number, size) => v / size, []);
};

export function SmallBezierSvg({
	//@ts-ignore
	displayValue,
	//@ts-ignore
	onClick,
	//@ts-ignore
	id,
	isInverted,
}: Pick<BezierProps, "displayValue" | "onUpdate"> & { withPreview: boolean } & {
	isInverted: boolean;
}) {
	const r = useRange();
	const ir = useInvertedRange();
	const [ref] = useMeasure();
	const svgRef = useRef<SVGSVGElement>(null);

	let temp = displayValue;
	const [x1, y1, x2, y2] = temp as unknown as number[];
	//TODO: make this dynamic
	let width = 35;
	let height = 35;

	const { sx, sy, ex, ey, cx1, cy1, cx2, cy2 } = useMemo(
		() => ({
			sx: r(0, width),
			sy: isInverted ? r(0, height) : r(1, height),
			ex: r(1, width),
			ey: isInverted ? r(1, height) : r(0, height),
			cx1: r(x1, width),
			cy1: isInverted ? r(y1, height) : r(1 - y1, height),
			cx2: r(x2, width),
			cy2: isInverted ? r(y2, height) : r(1 - y2, height),
		}),
		[r, x1, y1, x2, y2, width, height, isInverted]
	);

	return (
		<SmallSvg
			ref={mergeRefs([svgRef, ref])}
			withPreview={false}
			onClick={onClick}
			id={id}
			className=""
		>
			<line x1={sx} y1={sy} x2={ex} y2={ey} onClick={onClick} id={id} />
			<path
				fill="none"
				d={`M${sx},${sy} C${cx1},${cy1} ${cx2},${cy2} ${ex},${ey}`}
				strokeWidth="22"
				strokeDasharray="3,3"
				strokeLinecap="square"
				onClick={onClick}
				id={id}
			/>
		</SmallSvg>
	);
}
